<template>
  <div class="md:relative lg:relative md:pb-0 lg:pb-0 pb-10" id="joinpartner">
    <img
      src="@/assets/images/line/Vector 7.png"
      alt="lineimg"
      class="m-auto mob-hidden"
    />
    <div class="absolute bg-design51 md:block lg:block hidden">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="flex w-full flex-wrap items-center h-full">
      <div class="lg:w-1/2 md:w-1/2 w-full h-full flex items-center">
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Partnerwithus-partnership.jpg"
          alt=""
          class="m-auto custborderradius banner-short-w700 sm-mauto alignimg-aboutus md:block lg:block"
        />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full lg:pl-20 md:pl-10">
        <div class="lg:pt-0 md:pt-0 pt-3">
          <p class="title-semibold fsize36-24px">
            Collaborate with us to enable healthcare access
          </p>
          <p class="joinus-subtitle md:pt-10 lg:pt-10 pt-4 fsize24-14px">
            We are happy to partner with like-minded organisations in the
            healthcare sector who aim to deliver well-being for families.
            Partnering with us ensures you access to our strong network as well
            as a significant and growing caregivers’ community.
          </p>
          <div class="md:pt-10 lg:pt-10 pt-6">
            <!-- <a
              class="hover:text-white"
              target="_blank"
              href="https://forms.office.com/r/gie1XhrhDa"
            > -->
            <base-button
              type="primary"
              @click="handleRoute('request-form', 'partner-with-us')"
              class="md:px-10 lg:px-10 px-6 md:py-2 lg:py-2 py-1 font-semibold border-2 fsize18px"
              >Partnership</base-button
            >
            <!-- </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      this.toggleNavbar();
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
};
</script>
